import axios from 'axios';
import { ThreeDSecureRepository } from '@/repositories/ThreeDSecureRepository';
import { ErrorWithCode } from '@/common/customErrors';
import { Dictionary } from 'vue-router/types/router';

// threeDSecureAuth
// 3Dセキュア用パラメータの暗号化と3Dセキュア画面へのリダイレクトを行う。
// トークンを用いない決済の場合、第5引数を指定しない or undefinedを設定する。
export async function threeDSecureAuth(
  redirectUrl: string,
  tenantId: string,
  payAmount: number,
  billingFullName: string,
  payToken?: string
) {
  const repo = new ThreeDSecureRepository();
  let merchant_id, encrypt_value: string;
  try {
    const parameters = await repo.beginProcess(
      redirectUrl,
      tenantId,
      payAmount,
      billingFullName,
      payToken
    );
    if (!parameters.data.merchant_id || !parameters.data.encrypt_value) {
      throw new ErrorWithCode(500, 'invalid parameters returned');
    }
    merchant_id = parameters.data.merchant_id;
    encrypt_value = parameters.data.encrypt_value;
  } catch (e) {
    if (axios.isAxiosError(e)) {
      const res = e.response;
      throw new ErrorWithCode(
        res?.data?.code || res?.status || 500,
        'begin process request failed'
      );
    }
    throw e;
  }
  await repo.redirectToThreeDSecure(merchant_id, encrypt_value);
}

export function getThreeDSecureAuthResult(
  query: Dictionary<string | (string | null)[]>
) {
  if (
    !query ||
    !query['EncryptValue'] ||
    Array.isArray(query['EncryptValue'])
  ) {
    return '';
  }
  return query['EncryptValue'];
}
